import { permissionManager } from '@/utils/permission';

/** 与 routes.js 中 name 一致 */
export const ROUTE_FORBIDDEN_NAME = '403 Forbidden';

/**
 * 从匹配路由链中取最深层的路由权限配置
 */
export function getMatchedRouteMeta(routeTo) {
  const matched = routeTo.matched || [];
  for (let i = matched.length - 1; i >= 0; i--) {
    const meta = matched[i].meta;
    if (!meta) continue;
    if (meta.permission) return meta;
    if (meta.permissionsAny && meta.permissionsAny.length) return meta;
  }
  return null;
}

export function routeRequiresPermission(routeTo) {
  return !!getMatchedRouteMeta(routeTo);
}

export function checkRoutePermission(routeTo) {
  const meta = getMatchedRouteMeta(routeTo);
  if (!meta) return true;
  if (meta.permission) {
    return permissionManager.hasPermission(meta.permission);
  }
  if (meta.permissionsAny && meta.permissionsAny.length) {
    return permissionManager.hasAnyPermission(meta.permissionsAny);
  }
  return true;
}

export function forbiddenRouteLocation(routeTo) {
  const meta = getMatchedRouteMeta(routeTo);
  const permission = meta && meta.permission ? meta.permission : undefined;
  return {
    name: ROUTE_FORBIDDEN_NAME,
    query: {
      from: routeTo.fullPath,
      ...(permission ? { permission } : {}),
    },
  };
}
